import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, CheckCircle2, MessageCircle } from "lucide-react";
import { AuthShell, Field } from "./Login";
import api, { apiError } from "../lib/api";

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", username: "", email: "", whatsapp: "", password: "", confirm_password: "", address: "", agree: false });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [adminWhatsapp, setAdminWhatsapp] = useState("");

  useEffect(() => {
    api.get("/settings").then((response) => {
      setAdminWhatsapp(response.data?.contact_whatsapp || "");
    }).catch(() => setAdminWhatsapp(""));
  }, []);

  const whatsappUrl = () => {
    let number = adminWhatsapp.replace(/[^\d+]/g, "").replace(/^\+/, "");
    if (number.startsWith("0")) number = `62${number.slice(1)}`;
    const message = "Hallo Saya Sudah Mengajukan Pendaftaran sebagai Member di DS Kode";
    return number ? `https://wa.me/${number}?text=${encodeURIComponent(message)}` : "";
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm_password) return toast.error("Konfirmasi password tidak sama.");
    if (form.password.length < 8) return toast.error("Password minimal 8 karakter.");
    if (!form.agree) return toast.error("Anda harus menyetujui syarat & ketentuan.");
    setBusy(true);
    try {
      await api.post("/auth/register", form);
      setDone(true);
      toast.success("Registrasi berhasil");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <AuthShell title="Registrasi Berhasil" subtitle="Terima kasih telah mendaftar di DS KODE.">
        <div className="text-center py-4" data-testid="register-success">
          <span className="grid place-items-center h-14 w-14 rounded-full bg-emerald-50 text-emerald-600 mx-auto mb-4"><CheckCircle2 className="h-7 w-7" /></span>
          <p className="text-slate-600 mb-3">Registrasi berhasil. Akun Anda sedang menunggu persetujuan admin. Anda akan dapat login setelah akun disetujui.</p>
          <p className="text-sm text-slate-500 mb-4">Hubungi Admin Agar Segera disetujui</p>
          {whatsappUrl() && (
            <a href={whatsappUrl()} target="_blank" rel="noreferrer" className="mb-4 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 px-4 py-2.5 font-semibold text-white transition-colors hover:bg-emerald-700" data-testid="register-contact-admin-whatsapp">
              <MessageCircle className="h-4 w-4" /> WhatsApp Admin
            </a>
          )}
          <Link to="/login" className="btn-primary w-full">Ke Halaman Login</Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Daftar Member" subtitle="Buat akun untuk mengunduh produk digital.">
      <form onSubmit={submit} className="space-y-3.5">
        <Field label="Nama Lengkap"><input required value={form.name} onChange={set("name")} data-testid="reg-name" className="input" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Username"><input required value={form.username} onChange={set("username")} data-testid="reg-username" className="input" /></Field>
          <Field label="No. WhatsApp"><input required value={form.whatsapp} onChange={set("whatsapp")} data-testid="reg-whatsapp" className="input" placeholder="0812..." /></Field>
        </div>
        <Field label="Email"><input required type="email" value={form.email} onChange={set("email")} data-testid="reg-email" className="input" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Password"><input required type="password" value={form.password} onChange={set("password")} data-testid="reg-password" className="input" /></Field>
          <Field label="Konfirmasi"><input required type="password" value={form.confirm_password} onChange={set("confirm_password")} data-testid="reg-confirm" className="input" /></Field>
        </div>
        <Field label="Alamat"><textarea rows={2} value={form.address} onChange={set("address")} data-testid="reg-address" className="input" /></Field>
        <label className="flex items-start gap-2 text-sm text-slate-600"><input type="checkbox" checked={form.agree} onChange={set("agree")} data-testid="reg-agree" className="mt-0.5 rounded border-slate-300" /> Saya menyetujui syarat & ketentuan yang berlaku.</label>
        <button type="submit" disabled={busy} data-testid="register-submit" className="btn-primary w-full">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Daftar Sekarang"}</button>
      </form>
      <p className="mt-5 text-center text-sm text-slate-500">Sudah punya akun? <Link to="/login" className="font-semibold text-indigo-600 hover:underline">Masuk</Link></p>
    </AuthShell>
  );
}
